import React from "react";


import parseHTML from "html-react-parser";


import { ReactSVG } from "react-svg";


import {Col, Row} from "react-bootstrap";


import iconCheckbox from "@Icons/SVG/icon-check_box-m.svg";
import iconCheckboxChecked from "@Icons/SVG/icon-check_box-m--checked.svg";


import "./index.scss";


type FormCheckboxComponentProps = {
    labelText: string;
    checkedStatus: boolean;
    checkedStatusHandler: () => void;
    requiredStatus?: boolean;
};


export const FormCheckboxComponent:React.FC<FormCheckboxComponentProps> = ({
    labelText, requiredStatus, checkedStatus = false, checkedStatusHandler
}) => {


    const checkBoxIcon = checkedStatus ? iconCheckboxChecked : iconCheckbox;


    return (
        <Col xs={12} className={`form-checkbox-component`}>
            <Row className={`form-checkbox-component__content`}>

                <Col xs={'auto'} className={`form-checkbox-component__checkbox`}>
                    <ReactSVG
                        src={checkBoxIcon}
                        onClick={checkedStatusHandler}
                        wrapper={'span'}
                        className={`form-checkbox-component__checkbox__field`}
                    />
                </Col>

                <Col xs={'auto'} className={`form-checkbox-component__label`}>
                    {requiredStatus &&
                    <span className={`form-checkbox-component__label__required-status`}>*</span>
                    }
                    <span
                        className={`form-checkbox-component__label__text`}
                        // onClick={checkedStatusHandler}
                    >
                        {parseHTML(labelText)}
                    </span>
                </Col>

            </Row>
        </Col>
    );

};


export default FormCheckboxComponent;
